import { render, staticRenderFns } from "./Insurers.vue?vue&type=template&id=3e2ec32d&scoped=true"
import script from "./Insurers.vue?vue&type=script&lang=js"
export * from "./Insurers.vue?vue&type=script&lang=js"
import style0 from "./Insurers.vue?vue&type=style&index=0&id=3e2ec32d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2ec32d",
  null
  
)

export default component.exports